/* eslint-disable react/no-danger */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { parse, stringify } from 'query-string';
import React from 'react';

import * as AppPropTypes from '../../lib/PropTypes';

import { useWindowSize } from '../../contexts/SiteContext';
import Embed from '../partials/Embed';
import FloatingVideoSlot from '../partials/FloatingVideoSlot';

import styles from '../../../styles/blocks/embed.module.scss';

const propTypes = {
    small: PropTypes.bool,
    embed: AppPropTypes.embed,
    disableAutoPlay: PropTypes.bool,
    isContainer: PropTypes.bool,
    isVideoSlot: PropTypes.bool,
    className: PropTypes.string,
};

const defaultProps = {
    small: false,
    embed: null,
    disableAutoPlay: false,
    isContainer: false,
    isVideoSlot: false,
    className: null,
};

const EmbedBlock = ({
    small,
    embed,
    disableAutoPlay,
    isContainer,
    isVideoSlot: initialVideoSlot,
    className,
}) => {
    const { width: windowWidth = null } = useWindowSize();
    const isVideoSlot = initialVideoSlot || small;

    const {
        type = null,
        iframeUrl = null,
        video = null,
        width: embedWidth,
        height: embedHeight,
    } = embed || {};
    const { width: videoWidth = null, height: videoHeight = null } = video || {};

    const width = videoWidth || embedWidth || null;
    const height = videoHeight || embedHeight || null;
    const vertical = height !== null && width !== null && height > width;

    const isSlot = isVideoSlot && (type === 'video' || video === null);
    const isRegular = type === 'video' && iframeUrl != null && disableAutoPlay;

    // TODO: manage horizontal videos... oh god
    let containerHeight = windowWidth * 0.5625; // default
    if (isVideoSlot && width !== null && height !== null && width > 0 && height > 0) {
        // containerHeight = windowWidth * (height / width); // TODO: figure this one out... the ratio aint always good
        const ratio = height / width;
        if (height > width) {
            containerHeight = windowWidth < 500 ? windowWidth * ratio : containerHeight;
        } else {
            containerHeight = windowWidth * ratio;
        }
    }

    let regularUrl = null;
    if (isRegular) {
        // eslint-disable-next-line prefer-destructuring
        regularUrl = iframeUrl.split('?')[0];
        const urlParts = parse(iframeUrl);
        const { autoplay, autoPlay, ...others } = urlParts || {};
        const params = stringify({ ...others, autoPlay: 0, autoplay: 0 });
        regularUrl = `${regularUrl}?${params}`;
    }

    const content =
        isRegular && regularUrl !== null ? (
            <iframe
                src={iframeUrl}
                title="Video"
                style={{ width: '100%', aspectRatio: '16 / 9' }}
            />
        ) : (
            <Embed embed={embed} fullWidth withControls />
        );

    const slotWidth = vertical ? 180 : 320;
    const slotHeight = vertical ? 320 : 180;
    const isFullWidth = isVideoSlot && !small;

    return (
        <div
            className={classNames([
                styles.container,
                {
                    [styles.isContainer]: !small && isContainer,
                    [styles.isSmall]: small,
                    [styles.isFullWidth]: isFullWidth,
                    [className]: className !== null,
                },
            ])}
            style={
                !isFullWidth
                    ? {
                          width: !small ? '100%' : slotWidth,
                          height: !small ? containerHeight : slotHeight,
                      }
                    : { width: '100%', height: containerHeight }
            }
        >
            {isSlot ? (
                <FloatingVideoSlot name="embed" className={styles.videoSlot} fullWidth />
            ) : (
                content
            )}
        </div>
    );
};

EmbedBlock.propTypes = propTypes;
EmbedBlock.defaultProps = defaultProps;

export default EmbedBlock;
